import React, { useState } from "react";
import { BsArrowLeft } from "react-icons/bs";
import { useNavigate } from "react-router-dom";


const faqData = [
	{
		section: "General",
		items: [
			{
				q: "What is Skyboard?",
				a: "Skyboard is an online gaming platform where you can take part in futuristic races on flying boards. No download or installation is required—just play online!",
			},
			{
				q: "Is Skyboard free to use?",
				a: "Yes, you can sign up and play demo games for free. Some features and tournaments may require payment.",
			},
			{
				q: "What devices are supported?",
				a: "Skyboard works on most modern browsers on desktop, tablet, and mobile devices.",
			},
		],
	},
	{
		section: "Login",
		items: [
			{
				q: "I forgot my password. What should I do?",
				a: "Click on the 'Forgot Password' link on the login page and follow the instructions to reset your password.",
			},
			{
				q: "Can I log in with Google or Facebook?",
				a: "Yes, you can use your Google or Facebook account to sign in quickly and securely.",
			},
		],
	},
	{
		section: "Account",
		items: [
			{
				q: "How do I change my email address?",
				a: "Go to your profile settings, click on 'Edit Profile', and update your email address.",
			},
			{
				q: "How to logout from Skyboard?",
				a: "Click on your profile icon and select 'Logout' from the menu.",
			},
			{
				q: "How do I delete my account?",
				a: "Please contact our support team via the Help section to request account deletion.",
			},
		],
	},
	{
		section: "Payment",
		items: [
			{
				q: "Will I receive my winnings?",
				a: "Yes, all winnings are paid out according to our terms. Make sure your bank details are up to date in your profile.",
			},
			{
				q: "What payment methods are supported?",
				a: "We support bank transfers, credit/debit cards, and select mobile payment options.",
			},
			{
				q: "How long do withdrawals take?",
				a: "Withdrawals are usually processed within 1-3 business days, depending on your bank.",
			},
		],
	},
];

const filterOptions = ["General", "Login", "Account", "Payment"];

export default function FAQ() {
	const [selected, setSelected] = useState("General");
	const [openIdx, setOpenIdx] = useState(null);
      const navigate = useNavigate();

	// Find section for selected filter
	const filteredSection = faqData.find((s) => s.section === selected);

	return (
		<div className="min-h-screen bg-[#130828] flex flex-col items-center py-8 px-4">
            <div className="flex  items-center text-center w-full max-w-md relative mb-8">
             <button
                    className="mb-8"
                    onClick={() => navigate(-1)}
                    aria-label="Go back"
                  >
                    <BsArrowLeft  width={20} height={20} color="#fff" />
                  </button>
			<h2 className="text-white mx-auto text-2xl font-bold mb-8">FAQ</h2>
            </div>
			{/* Filter Buttons */}
			<div className="flex flex-wrap gap-3 mb-6 justify-center w-full max-w-md">
				{filterOptions.map((opt) => (
					<button
						key={opt}
						className={`px-4 py-2 rounded-full text-sm font-semibold transition border border-[#BD3193] ${
							selected === opt
								? "bg-[#BD3193] text-white"
								: "bg-transparent text-[#BD3193]"
						}`}
						onClick={() => {
							setSelected(opt);
							setOpenIdx(null);
						}}
					>
						{opt}
					</button>
				))}
			</div>
			<div className="w-full max-w-md   shadow-lg overflow-y-auto max-h-[500px]">
				{filteredSection && filteredSection.items.length > 0 ? (
					<div className="mb-6">
			
						<ul className="space-y-6 ">
							{filteredSection.items.map((item, idx) => (
								<li key={item.q} className="rounded-xl bg-gradient-to-r from-[#BD3193] to-[#9FCC3B] p-[2px]">
	<div className="bg-[#252525] rounded-xl overflow-hidden">
		<button
			className="w-full flex justify-between items-center text-left text-white font-medium px-4 py-3 transition"
			onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
		>
			<span>{item.q}</span>
			<span
				className={`ml-2 text-[#BE3593] transition-transform ${
					openIdx === idx ? "rotate-90" : ""
				}`}
			>
				▶
			</span>
		</button>
    
		{openIdx === idx && (
            
			<div className="text-gray-300 text-sm px-4 pb-4 animate-fade-in">
                    <hr className="border-gray-600 mb-2" />
				{item.a}
			</div>
		)}
	</div>
</li>

							))}
						</ul>
					</div>
				) : (
					<div className="text-gray-400 text-center">
						No questions available.
					</div>
				)}
			</div>
		</div>
	);
}
